import { render, staticRenderFns } from "./email.vue?vue&type=template&id=114023a0&scoped=true&"
import script from "./email.vue?vue&type=script&lang=js&"
export * from "./email.vue?vue&type=script&lang=js&"
import style0 from "./email.vue?vue&type=style&index=0&id=114023a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "114023a0",
  null
  
)

export default component.exports